var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { SystemIcon } from '@storeblocks/icon';
import Hint from '@storeblocks/hint';
import { Popover } from '@storeblocks/popover';
import { RadioBase, Attention as StyledAttention, MainLabel as StyledMainLabel, } from './styled';
import { RadioOptions } from './RadioOptions';
export const Radio = forwardRef((_a, ref) => {
    var { id, name, label, hint, disabled = false, error, warning, onChange, value, options, direction, hintProps, labelPopoverProps } = _a, props = __rest(_a, ["id", "name", "label", "hint", "disabled", "error", "warning", "onChange", "value", "options", "direction", "hintProps", "labelPopoverProps"]);
    if (error && warning) {
        throw new Error('Cannot assign both error and warning properties, must choose one or the other.');
    }
    const labelId = `${id}-radio-label`;
    const errorId = `${id}-radio-error`;
    const warningId = `${id}-radio-warning`;
    const ariaLabelledBy = `${labelId} ${warningId} ${errorId}`;
    return (React.createElement(RadioBase, Object.assign({ role: "radiogroup", ref: ref, "$error": error, "$warning": warning, "aria-disabled": disabled, "aria-labelledby": ariaLabelledBy }, props),
        React.createElement(Attention, { errorId: errorId, error: error, warningId: warningId, warning: warning }),
        React.createElement(MainLabel, { warning: warning, error: error, label: label, labelId: labelId, labelPopoverProps: labelPopoverProps }),
        React.createElement(MainHint, { hint: hint, hintProps: hintProps }),
        React.createElement(RadioOptions, { id: id, name: name, onChange: onChange, value: value, options: options, disabled: disabled, direction: direction })));
});
function AttentionWarning({ warningId, warning, }) {
    return (React.createElement(StyledAttention, { id: warningId, role: "alert", "$warning": warning },
        React.createElement(SystemIcon, { name: "warning-filled" }),
        warning));
}
function AttentionError({ errorId, error, }) {
    return (React.createElement(StyledAttention, { id: errorId, role: "alert", "$error": error },
        React.createElement(SystemIcon, { name: "error-filled" }),
        error));
}
function Attention({ warningId, warning, errorId, error }) {
    if (error) {
        return React.createElement(AttentionError, { errorId: errorId, error: error });
    }
    if (warning) {
        return React.createElement(AttentionWarning, { warningId: warningId, warning: warning });
    }
    return null;
}
function MainLabel({ warning, error, label, labelId, labelPopoverProps, }) {
    const attention = !!(warning || error);
    if (!label) {
        return null;
    }
    return (React.createElement(StyledMainLabel, { id: labelId, attention: attention },
        label,
        labelPopoverProps && (React.createElement(Popover, Object.assign({}, labelPopoverProps), labelPopoverProps.children))));
}
function MainHint({ hintProps, hint }) {
    if (!hint) {
        return null;
    }
    return React.createElement(Hint, Object.assign({}, hintProps), hint);
}
